import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { NO_RESET_WHITE_LIST } from '@/constants'
import EmptyLayout from './EmptyLayout.vue'

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/CheckingIn',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: '登录',
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/CheckingIn',
    redirect: '/CheckingIn/home/AttendanceNavigation',
    meta: {
      hidden: true,
      icon: 'records-o',
      title: '考勤',
      noTagsView: true
    },
    children: [
      {
        path: 'home',
        meta: {
          hidden: true,
          icon: 'records-o',
          title: '考勤',
          noTagsView: true
        },
        children: [
          {
            path: 'AttendanceNavigation',
            component: () => import('@/views/CheckingIn/Home/index.vue'),
            name: 'AttendanceNavigation',
            meta: {
              title: '考勤',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'LeaveApplication',
            component: () => import('@/views/CheckingIn/Home/LeaveApplication/index.vue'),
            name: 'LeaveApplication',
            meta: {
              title: '请假申请',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'OvertimeApplication',
            component: () => import('@/views/CheckingIn/Home/OvertimeApplication/index.vue'),
            name: 'OvertimeApplication',
            meta: {
              title: '加班申请',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'TravelApplication',
            component: () => import('@/views/CheckingIn/Home/TravelApplication/index.vue'),
            name: 'TravelApplication',
            meta: {
              title: '出差申请',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ApplicationForGoingOut',
            component: () => import('@/views/CheckingIn/Home/ApplicationForGoingOut/index.vue'),
            name: 'ApplicationForGoingOut',
            meta: {
              title: '外出申请',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'UniformedPaidLeave',
            component: () => import('@/views/CheckingIn/Home/UniformedPaidLeave/index.vue'),
            name: 'UniformedPaidLeave',
            meta: {
              title: '外出申请',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'ApprovedByMe',
        component: EmptyLayout,
        name: 'ApprovedByMe',
        meta: {
          hidden: true,
          icon: 'search',
          title: '我的审批',
          noTagsView: true
        },
        children: [
          {
            path: 'index',
            name: 'ApprovedByMes',
            component: () => import('@/views/CheckingIn/ApprovedByMe/index.vue'),
            meta: {
              hidden: true,
              title: '我的审批',
              noTagsView: true
            }
          },
          {
            path: 'LeaveApprovalProcess',
            component: () =>
              import('@/views/CheckingIn/ApprovedByMe/LeaveApprovalProcess/index.vue'),
            name: 'LeaveApprovalProcess',
            meta: {
              noCache: true,
              title: '请假审批流程',
              noTagsView: true
            }
          },
          {
            path: 'OvertimeApprovalProcess',
            component: () =>
              import('@/views/CheckingIn/ApprovedByMe/OvertimeApprovalProcess/index.vue'),
            name: 'OvertimeApprovalProcess',
            meta: {
              noCache: true,
              title: '加班审批流程',
              noTagsView: true
            }
          },
          {
            path: 'ApprovalProcedureForGoingOut',
            component: () =>
              import('@/views/CheckingIn/ApprovedByMe/ApprovalProcedureForGoingOut/index.vue'),
            name: 'ApprovalProcedureForGoingOut',
            meta: {
              noCache: true,
              title: '外出审批流程',
              noTagsView: true
            }
          }
        ]
      },
      {
        path: 'Initiated',
        component: EmptyLayout,
        name: 'Initiated',
        meta: {
          hidden: true,
          icon: 'friends-o',
          title: '我发起的',
          noTagsView: true
        },
        children: [
          {
            path: 'index',
            name: 'Initiateds',
            component: () => import('@/views/CheckingIn/Initiated/index.vue'),
            meta: {
              hidden: true,
              title: '我发起的',
              noTagsView: true
            }
          },
          {
            path: 'ProcessDetails',
            component: () => import('@/views/CheckingIn/Initiated/ProcessDetails/index.vue'),
            name: 'ProcessDetails',
            meta: {
              noCache: true,
              title: '流程详情',
              noTagsView: true
            }
          },
          {
            path: 'GoOutDetails',
            component: () => import('@/views/CheckingIn/Initiated/GoOutDetails/index.vue'),
            name: 'GoOutDetails',
            meta: {
              noCache: true,
              title: '外出详情',
              noTagsView: true
            }
          }
        ]
      },
      {
        path: 'statistics',
        component: EmptyLayout,
        name: 'statistics',
        meta: {
          hidden: true,
          icon: 'setting-o',
          title: '统计',
          noTagsView: true
        },
        children: [
          {
            path: 'index',
            name: 'statisticst',
            component: () => import('@/views/CheckingIn/Statistics/index.vue'),
            meta: {
              hidden: true,
              title: '统计',
              noTagsView: true
            }
          },
          {
            path: 'PunchCalendar',
            component: () => import('@/views/CheckingIn/Statistics/PunchCalendar/index.vue'),
            name: 'PunchCalendar',
            meta: {
              noCache: true,
              title: '打卡月历',
              noTagsView: true
            }
          }
        ]
      }
    ]
  },
  // 项目管理
  {
    path: '/ProjectManagement',
    redirect: '/ProjectManagement/home',
    meta: {
      hidden: true,
      prefix: 'iconfont',
      icon: 'records-o',
      title: '项目管理',
      noTagsView: true
    },
    children: [
      {
        path: 'home',
        redirect: '/ProjectManagement/home/ProjectList',
        meta: {
          hidden: true,
          prefix: 'iconfont',
          icon: 'project',
          title: '项目管理',
          noTagsView: true
        },
        children: [
          {
            path: 'ProjectList',
            component: () => import('@/views/ProjectManagement/ProjectList/index.vue'),
            name: 'ProjectList',
            meta: {
              title: '项目管理',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectDetails',
            component: () => import('@/views/ProjectManagement/ProjectList/details.vue'),
            name: 'ProjectDetails',
            meta: {
              title: '项目详情',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectInvoice',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/ProjectInvoice/index.vue'),
            name: 'ProjectInvoice',
            meta: {
              title: '项目发票',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectInvoiceDetails',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/ProjectInvoice/details.vue'),
            name: 'ProjectInvoiceDetails',
            meta: {
              title: '项目发票详情',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectProcurementList',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/ProjectProcurement/index.vue'),
            name: 'ProjectProcurementList',
            meta: {
              title: '项目采购',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectProcurementAdd',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/ProjectProcurement/add.vue'),
            name: 'ProjectProcurementAdd',
            meta: {
              title: '项目采购',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'ProjectProcurementDetails',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/ProjectProcurement/details.vue'),
            name: 'ProjectProcurementDetails',
            meta: {
              title: '项目采购详情',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'PurchaseInvoiceList',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/PurchaseInvoice/index.vue'),
            name: 'PurchaseInvoiceList',
            meta: {
              title: '采购发票',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'PurchaseInvoiceAdd',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/PurchaseInvoice/add.vue'),
            name: 'PurchaseInvoiceAdd',
            meta: {
              title: '新增采购发票',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'PurchaseInvoiceDetails',
            component: () =>
              import('@/views/ProjectManagement/ProjectList/PurchaseInvoice/details.vue'),
            name: 'PurchaseInvoiceDetails',
            meta: {
              title: '采购发票详情',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'CommodityWarehouse',
        redirect: '/ProjectManagement/CommodityWarehouse/CommodityList',
        meta: {
          hidden: true,
          prefix: 'iconfont',
          icon: 'commodity-warehouse',
          title: '商品库',
          noTagsView: true
        },
        children: [
          {
            path: 'CommodityList',
            component: () => import('@/views/ProjectManagement/CommodityWarehouse/index.vue'),
            name: 'CommodityList',
            meta: {
              title: '商品库',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'CommodityDetails',
            component: () => import('@/views/ProjectManagement/CommodityWarehouse/details.vue'),
            name: 'CommodityDetails',
            meta: {
              title: '商品库详情',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'Supplier',
        redirect: '/ProjectManagement/Supplier/SupplierList',
        meta: {
          hidden: true,
          prefix: 'iconfont',
          icon: 'supplier',
          title: '供应商',
          noTagsView: true
        },
        children: [
          {
            path: 'SupplierList',
            component: () => import('@/views/ProjectManagement/Supplier/index.vue'),
            name: 'SupplierList',
            meta: {
              title: '供应商',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'SupplierDetails',
            component: () => import('@/views/ProjectManagement/Supplier/details.vue'),
            name: 'SupplierDetails',
            meta: {
              title: '供应商详情',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'ClientCompany',
        redirect: '/ProjectManagement/ClientCompany/ClientCompanyList',
        meta: {
          hidden: true,
          prefix: 'iconfont',
          icon: 'customer-company',
          title: '客户公司',
          noTagsView: true
        },
        children: [
          {
            path: 'ClientCompanyList',
            component: () => import('@/views/ProjectManagement/ClientCompany/index.vue'),
            name: 'ClientCompanyList',
            meta: {
              title: '客户公司',
              noCache: true,
              affix: true
            }
          },

          {
            path: 'ClientCompanyDetails',
            component: () => import('@/views/ProjectManagement/ClientCompany/details.vue'),
            name: 'ClientCompanyDetails',
            meta: {
              title: '客户公司详情',
              noCache: true,
              affix: true
            }
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
